<script>
import Dropdown from 'primevue/dropdown';

export default {
    components: { Dropdown },
    props: ['field', 'value', 'disabled', 'api', 'format', 'sortField', 'name', 'localized', 'changeFn'],
    data(){
        return {
           
        }
    },
    mounted(){
        this.loadOptions();
    },
    computed: {
        options(){
            return this.$store.state.masterData[this.name];
        }
    },
    methods: {
        loadOptions(){
            if(!this.options){
                let params = {}
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }

                let payload = {
                    params: params,
                    name: this.name,
                    api: this.api
                };
                this.$store.dispatch("masterData/loadData", payload);
            }
        },
        onChange(e){
            if(this.changeFn){
                let p = this.options.filter((el) => {
                    return el.value == e.value;
                });
                this.changeFn(p[0])
            }

        }
    }
}


</script>


<template>
    <Dropdown :options="options" :filter="true" optionLabel="label" optionValue="value" :disabled="this.disabled" :showClear="true" @change="onChange">
        <template #value="slotProps" v-if="localized">
            <span>{{$t(slotProps.value)}}</span>
        </template>
        <template #option="slotProps" v-if="localized">
            <span>{{$t(slotProps.option.label)}}</span>
        </template>
    </Dropdown>
</template>